import { render } from "./harvesterhci.io.virtualmachinetemplateversion.vue?vue&type=template&id=2cf5ba2c"
import script from "./harvesterhci.io.virtualmachinetemplateversion.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.virtualmachinetemplateversion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__